











































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import { State, Getter } from 'vuex-class';
import { Component, Prop } from 'vue-property-decorator';
import { FinancialInstitutionState, FinancialInstitution } from '@/store/financial-institution/types';
import { ProductInformation, ProductInformationState } from '@/store/product-information/types';

const fiNamespace = 'financialInstitution';
const productNameSpace = 'productInformation';

@Component({
	name: 'landing-page'
})

export default class LandingPage extends Vue {
	@Prop({required: true }) isCash!: boolean;
	@State('financialInstitution') financialInstitution?: FinancialInstitutionState;
	@Getter('fiCompany', { namespace:fiNamespace }) fiCompany?: FinancialInstitution;
	@State('productInformation') productInformation?: ProductInformationState;
	@Getter('product', { namespace:productNameSpace }) product?: ProductInformation;

	data() {
		return {
			overlay: true,
		};
	}

	computed() {
		this.product;
	}

	created() {
		this.$eventBus.$on('image-loaded', () => {
		this.$data.overlay = false;
		});
	}

	beforeDestroy() {
		this.$eventBus.$off('image-loaded');
	}

	startApplication() {
		const button = document.getElementById('apply-now-button');
		if (button != null) {
			button.classList.remove('apply-now-button');
			button.classList.add('apply-now-button-disabled-button-after-click');
		}
		this.$emit('startApplication');
	}

	hasAtmReward() {
		if(this.product?.atmReward != undefined && this.product?.atmReward?.productContains == true){
			return true;
		} else {
			return false;
		}
	}

	scrollToSchumerBox(){
		const schumerBox = document.getElementById('schumer-box');
		schumerBox?.scrollIntoView(true);
	}
}
